"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

exports.WrappingChildren = function (props) {
  var Wrapper = props.with,
      _a = props.wrapperProps,
      wrapperProps = _a === void 0 ? {} : _a;
  return React.createElement(React.Fragment, null, React.Children.toArray(props.children).map(function (child, index) {
    return React.createElement(Wrapper, __assign({
      key: index
    }, wrapperProps), child);
  }));
};